import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { ShopLocatorStateModule } from "@hermes/states/shop-locator";

import { ProductLocatorEffects } from "./product-locator.effects";
import { ProductLocatorFacade } from "./product-locator.facade";
import * as fromProductLocator from "./product-locator.reducer";
import { ProductLocatorService } from "./product-locator.service";
import { LoadGeoLibrariesServiceModule } from "@hermes/map-utils";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromProductLocator.PRODUCT_LOCATOR_FEATURE_KEY,
            fromProductLocator.reducer,
        ),
        EffectsModule.forFeature([ProductLocatorEffects]),
        ShopLocatorStateModule,
        LoadGeoLibrariesServiceModule,
    ],
    providers: [ProductLocatorFacade, ProductLocatorService],
})
export class ProductLocatorStateModule {}
